"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TranscriptOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_TranscriptOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8a8 8 0 0 0 10.567 7.58.475.475 0 0 0 .29-.604.529.529 0 0 0-.671-.324 6.865 6.865 0 0 1-.323.097c.464-.678.855-1.598 1.138-2.672L11 12V9c0-.606.18-1.17.488-1.64A17.17 17.17 0 0 0 11.384 6h4.364A8 8 0 0 0 0 8Zm1.29 2A7.001 7.001 0 0 1 1 8c0-.695.101-1.366.29-2h3.326a17.361 17.361 0 0 0-.003 4H1.29Zm.384 1a7.017 7.017 0 0 0 4.463 3.75c-.613-.896-1.097-2.213-1.376-3.75H1.674Zm4.105 0c.163.84.391 1.594.663 2.222.285.656.6 1.129.898 1.423.295.29.517.355.66.355.143 0 .365-.065.66-.355.299-.294.613-.767.898-1.423.272-.628.5-1.382.663-2.222H5.78Zm-.158-1a16.313 16.313 0 0 1 .002-4h4.754a16.327 16.327 0 0 1 .002 4H5.621Zm-.856-5H1.674a7.017 7.017 0 0 1 4.468-3.75C5.53 2.144 5.044 3.462 4.765 5Zm1.678-2.212c-.27.626-.498 1.377-.66 2.212h4.435a10.901 10.901 0 0 0-.661-2.212c-.285-.66-.6-1.135-.898-1.431C8.363 1.064 8.14 1 8 1c-.141 0-.363.064-.659.357-.299.296-.613.772-.898 1.431ZM11.235 5h3.091a7.017 7.017 0 0 0-4.468-3.75c.612.895 1.098 2.213 1.377 3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7a2 2 0 0 0-2 2v3a2 2 0 0 0 1.5 1.937V15h-1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-1v-1.063A2 2 0 0 0 16 12V9a2 2 0 0 0-2-2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_TranscriptOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = TranscriptOutline;
exports["default"] = _default;